import { render } from "./ContactImportPage.vue?vue&type=template&id=5b4f860b"
import script from "./ContactImportPage.vue?vue&type=script&lang=js"
export * from "./ContactImportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__